import type { ServicesProvided } from '../../API/services/FacilityService';

const facilityInitialValues = {
  facilityInfo: {
    id: 0,
    name: '',
    status: true,
    facilityBusinessId: '',
    facilityTypeId: 0,
    alias: '',
    partnerId: 0,
    shortName: '',
    servicesProvided: [] as ServicesProvided[],
    website: '',
    utilizeScribes: false,
    activeFacilitySince: '',
    intakeFormId: 0,
    terminationDate: '',
    assignedTo: 0,
    videoConferenceTypeId: 0,
    customLink: '',
    isCustomLink: false,
    minimumAgeRequired: '0',
    isHidePhiAfterCompletion: false,
  },
  contactDetails: {
    id: 0,
    primaryPhone: '',
    itHelpDeskEmail: '',
    edPhone: '',
    icuPhone: '',

    medSurgPhone: '',

    itHelpDeskPhone: '',
    otherFax: '',
    otherFaxDescription: '',
    secureFax: '',
    other: '',
  },

  itSystemDetails: {
    id: 0,
    networkAccessType: '',
    telemedicinePlatform: '',
    networkAccessUrl: '',
    telemedicinePlatformUrl: '',
    vpnGatewaySoftware: '',
    qlerViewUsername: '',
    emr: '',
    epicContext: '',
    devicesUtilized: '',
    documentationIn: '',
    trainingRequirements: '',
    mfa: '',
    itNotes: '',
    portalUnPw: '',
  },
  address: {
    id: 0,
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '0',
    postalCode: '',
    county: '',
  },
  description: '',
};
export default facilityInitialValues;
